import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

interface SectionsTitleProps extends PropsWithChildren {
  className?: string;
  title?: string;
}
export function SectionsTitle({ children, className }: SectionsTitleProps) {
  return (
    <SectionsTitleComponent className={className}>
      {children}
    </SectionsTitleComponent>
  );
}

export const SectionsTitleComponent = styled.div`
  font-size: ${({
    theme: {
      sectionTitleFontStyle: { fontSize }
    }
  }) => fontSize}px;
  line-height: 1.333;
  margin-bottom: 32px;
  font-weight: ${({
    theme: {
      sectionTitleFontStyle: { fontWeight }
    }
  }) => fontWeight};
  display: flex;
  align-items: center;
  text-transform: ${({
    theme: {
      sectionTitleFontStyle: { textTransform }
    }
  }) => textTransform};
`;
